import css from './style.module.css';
export default function NoCompanies() {
    return (
        <div className={css.emptyState}>
            <i className={`fas fa-building ${css.emptyIcon}`}></i>
            <h4 className={css.emptyTitle}>No companies found</h4>
            <p className={css.emptyText}>
                Try adjusting your search or add a new client to get started
            </p>
        </div>
    )
}
